export default __webpack_public_path__ + "static/media/typescript.8d9549db.svg";